import { Data } from "../../../context/OperadorContext";
import { formatMoney } from "../../../utils/formatMoney";
import { Loader } from "../../generics/loader";

interface ListInfosProps {
  data: Data | null;
}

export default function ListInfos({ data }: ListInfosProps) {
  return (
    <div className="mt-2 flex w-[100%] space-x-4">
      {!data ? (
        <div className="flex w-[100%] items-center justify-center rounded-lg border p-4">
          <Loader />
        </div>
      ) : (
        <>
          <fieldset className="mt-2 flex w-[100%] space-x-2 border border-slate-300 rounded-md py-2 px-2">
            <legend className="text-primary font-semibold text-base">Dados da Fila</legend>
            <div className="w-[100%] rounded-lg border p-2">
              <h1 className="text-xl font-semibold">{data.a_cobrar}</h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">
                Fila loja
              </p>
            </div>

            <div className="w-[100%] rounded-lg border p-2">
              <h1 className="text-xl font-semibold">{data.contratos}</h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">Contratos</p>
            </div>

            <div className="w-[100%] rounded-lg border p-2">
              <h1 className="text-xl font-semibold">
                {formatMoney(data.valor_vencido)}
              </h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">Valor vencido</p>
            </div>

            <div className="w-[100%] rounded-lg border p-2">
              <h1 className="text-xl font-semibold">
                {formatMoney(data.valor_a_vencer)}
              </h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">Valor a vencer</p>
            </div>
          </fieldset>

          {/* Tirar na hora de subir */}
          {/* {formatMoney(data.valor_a_vencer)} */}
          <fieldset className="mt-2 flex w-[100%] space-x-2 border border-slate-300 rounded-md p-2">
            <legend className="text-primary font-semibold text-base">Produção do dia</legend>
            <div className="w-[100%] rounded-lg border p-2 bg-blue-50">
              <h1 className="text-xl font-semibold">

                {data?.producao ? data?.producao?.acionamentos : '-'}
              </h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">Acionados</p>
            </div>
            <div className="w-[100%] rounded-lg border p-2 bg-blue-50">
              <h1 className="text-xl font-semibold">

                {data?.producao ? data?.producao?.agendamentos : '-'}
              </h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">Agendados</p>
            </div>
            <div className="w-[100%] rounded-lg border p-2 bg-blue-50">
              <h1 className="text-xl font-semibold">
                {data?.producao ? formatMoney(Number(data?.producao?.valor_agendado)) : 'R$ 0,00'}
              </h1>
              <p className="mt-2 font-semibold text-slate-400 text-sm">Valor Agendado</p>
            </div>
          </fieldset>
        </>
      )}
    </div>
  );
}
